export const onLoadScriptSoporte = () => {
  let dataPayphoneScript = document.createElement("script");
  dataPayphoneScript.type = "text/javascript";
  dataPayphoneScript.defer = true;
  dataPayphoneScript.text = `
 
  (function(a,m,o,c,r,m){a[m]={id:"1065243",hash:"a6caff718f708da497327491a49cb7ef51fa05b40e07ce28eeb7f4343b744ab4",locale:"es",setMeta:function(p){this.params=(this.params||[]).concat([p])}};a[o]=a[o]||function(){(a[o].q=a[o].q||[]).push(arguments)};var d=a.document,s=d.createElement('script');s.async=true;s.id=m+'_script';s.src='https://gso.kommo.com/js/button.js';d.head&&d.head.appendChild(s)}(window,0,'crmPlugin',0,0,'crm_plugin'))
    
    
  `;
  document.head.appendChild(dataPayphoneScript);
};
